import React from 'react';

function MainEmailArea1({children}) {
    return (
        <div className="h-full w-rb overflow-hidden">
             <div className="block h-full">
                {children}
            </div>
        </div>
    );
}

export default MainEmailArea1;